import { NCALayerStatuses, NCALayerModes } from "@/config/consts";
import { BaseModule } from "@/store/base.module";
import { translate } from "@/utils";
import { Catch } from "@/utils/decorators";
import { AxiosError } from "axios";
import { EDSConfig, SignKey } from "~/eds.type";
import { Api } from "./api.service";

export class SignService {
  public static async signXML(
    storageType: string,
    content: string,
    options: EDSConfig,
  ): Promise<MessageValue<string | boolean>> {
    return new Promise(resolve => {
      const webSocket = new WebSocket("wss://127.0.0.1:13579/");
      webSocket.onopen = function () {
        // у методов для Xml и Base64 разные аргументы
        const xmlArgs = options.signBlockById
          ? [...options.signBlockById]
          : ["", ""];
        const base64args = [false]
        const args =
          options.signMethod === NCALayerModes.base64 ? base64args : xmlArgs;
        const payload = {
          module: "kz.gov.pki.knca.commonUtils",
          method: options.signMethod,
          args: [storageType, options.signKey, content, ...args],
        };
        webSocket.send(JSON.stringify(payload));
      };

      webSocket.onclose = function(event) {
        if (!event.wasClean) {
          BaseModule.showMessage({
            message: translate("eds.error") as string,
            color: "error",
          });
          resolve({
            result: false,
            message: NCALayerStatuses.NOT_CONNECTED,
          });
        }
      };

      webSocket.onmessage = function (event) {
        const result = JSON.parse(event.data);
        if (result && result["code"]) {
          switch (result["code"]) {
            case "500":
              resolve({
                result: false,
                message: "NCALayer: " + result["message"],
              });
              break;
            case "200":
              resolve({ result: result["responseObject"] });
              break;
          }
          webSocket.close();
        }
      };
    });
  }

  @Catch((e: AxiosError) => {
    return {
      result: false,
      message: e.response?.data.message,
    };
  })
  public static async validateEDS(
    data: string,
    action: SignKey,
    bin?: string,
  ): Promise<{ result: Dictionary; message?: ApiMessageObject }> {
    const result = await Api.post("eds/validate", {
      signedData: data,
      action,
      bin,
    });
    return {
      result: result.data,
    };
  }
}
